import { render, staticRenderFns } from "./KaiSpeaker.vue?vue&type=template&id=63b5b85a&scoped=true&"
import script from "./KaiSpeaker.vue?vue&type=script&lang=ts&"
export * from "./KaiSpeaker.vue?vue&type=script&lang=ts&"
import style0 from "./KaiSpeaker.vue?vue&type=style&index=0&id=63b5b85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5b85a",
  null
  
)

export default component.exports